/* Renders the small amount of inline markup CMS editors are allowed, as real React nodes.
 *
 * The alternative is dangerouslySetInnerHTML, which is what the hero heading used before. Even
 * behind a sanitiser that is a standing invitation for the allowlist to drift, and a CMS field is
 * not trusted input just because only staff can write to it. Producing nodes means unknown markup
 * cannot be rendered at all rather than merely being filtered on the way past.
 */
const TOKEN = /<(strong|em|b|i)>([\s\S]*?)<\/\1>|<br\s*\/?>/gi;

const TAGS = { strong: "strong", b: "strong", em: "em", i: "em" };

// Anything outside the allowlist is dropped, tag and all, before tokenising.
const stripDisallowed = (input) =>
  String(input || "").replace(
    /<(?!\/?(?:strong|em|b|i|br)\s*\/?>)[^>]*>/gi,
    "",
  );

const richText = (input) => {
  const source = stripDisallowed(input).trim();
  if (!source) return null;

  const nodes = [];
  let cursor = 0;
  let match;

  TOKEN.lastIndex = 0;
  while ((match = TOKEN.exec(source)) !== null) {
    if (match.index > cursor) nodes.push(source.slice(cursor, match.index));

    if (match[1]) {
      const Tag = TAGS[match[1].toLowerCase()];
      nodes.push(<Tag key={`${match.index}-${match[1]}`}>{match[2]}</Tag>);
    } else {
      nodes.push(<br key={`${match.index}-br`} />);
    }
    cursor = match.index + match[0].length;
  }

  if (cursor < source.length) nodes.push(source.slice(cursor));

  // Returned as a bare array: the elements already carry keys derived from their offset in the
  // source, and plain strings in a children array never need one.
  return nodes;
};

export default richText;
